import { environment } from '../../../../environments/environment';
import { Injectable, inject } from '@angular/core';
import { Translation } from '../translation';
import { HttpClient } from '@angular/common/http';

export interface TranslationResponse {
  data: Array<Translation>;
  error: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class RestTranslationService {
  private readonly http = inject(HttpClient);

  getAllTranslations() {
    const url = environment.translationUrl + environment.serviceUris.translations;

    return this.http.get<TranslationResponse>(url);
  }
}
